import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
// 解决重复点击导航路由报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
    {path: "*", redirect: "/login"},
    {
        path: "/login",
        name: "login",
        component: () => import("../views/login.vue")
    },
    {
        path: "/auth",
        name: "auth",
        component: () => import("../views/auth.vue")
    },
    {
        path: "/home",
        name: "home",
        redirect: "/user",
        component: () => import("../views/home.vue"),
        children: [
            {
                // 组织管理
                path: "/dept",
                name: "dept",
                meta: {
                    title: "/\xa0\xa0\xa0组织管理",
                    superior: "/\xa0\xa0\xa0系统管理"
                },
                component: () => import("../views/system/dept.vue")
            },
            {
                // 菜单管理
                path: "/menu",
                name: "menu",
                meta: {
                    title: "/\xa0\xa0\xa0菜单管理",
                    superior: "/\xa0\xa0\xa0系统管理"
                },
                component: () => import("../views/system/menu.vue")
            },
            {
                // 岗位管理
                path: "/post",
                name: "post",
                meta: {
                    title: "/\xa0\xa0\xa0岗位管理",
                    superior: "/\xa0\xa0\xa0系统管理"
                },
                component: () => import("../views/system/post.vue")
            },
            {
                // 角色管理
                path: "/role",
                name: "role",
                meta: {
                    title: "/\xa0\xa0\xa0角色管理",
                    superior: "/\xa0\xa0\xa0系统管理"
                },
                component: () => import("../views/system/role.vue")
            },
            {
                // 员工管理
                path: "/user",
                name: "user",
                meta: {
                    title: "/\xa0\xa0\xa0员工管理",
                    superior: "/\xa0\xa0\xa0系统管理"
                },
                component: () => import("../views/system/user.vue")
            },
            {
                // 员工管理
                path: "/statuses",
                name: "statuses",
                meta: {
                    title: "/\xa0\xa0\xa0员工管理",
                    superior: "/\xa0\xa0\xa0系统管理"
                },
                component: () => import("../views/system/statuses.vue")
            },
            {
                // 房东管理
                path: "/landlordManagement",
                name: "landlordManagement",
                meta: {
                    title: "/\xa0\xa0\xa0房东管理",
                    superior: "/\xa0\xa0\xa0会员管理"
                },
                component: () => import("../views/member/landlordManagement.vue")
            },
            {
                // 房东详情
                path: "/landlordDetails",
                name: "landlordDetails",
                meta: {
                    title: "/\xa0\xa0\xa0房东详情",
                    superior: "/\xa0\xa0\xa0会员管理"
                },
                component: () => import("../views/member/landlordDetails.vue")
            },
            {
                // 房客管理
                path: "/tenantManagement",
                name: "tenantManagement",
                meta: {
                    title: "/\xa0\xa0\xa0房客管理",
                    superior: "/\xa0\xa0\xa0会员管理"
                },
                component: () => import("../views/member/tenantManagement.vue")
            },
            {
                // 房客详情
                path: "/tenantParticulars",
                name: "tenantParticulars",
                meta: {
                    title: "/\xa0\xa0\xa0房客详情",
                    superior: "/\xa0\xa0\xa0会员管理"
                },
                component: () => import("../views/member/tenantParticulars.vue")
            },
            {
                // 会员列表
                path: "/thememberlist",
                name: "thememberlist",
                meta: {
                    title: "/\xa0\xa0\xa0会员列表",
                    superior: "/\xa0\xa0\xa0会员管理"
                },
                component: () => import("../views/member/thememberlist.vue")
            },
            {
                // 会员详情
                path: "/thememberlistDeta",
                name: "thememberlistDeta",
                meta: {
                    title: "/\xa0\xa0\xa0会员详情",
                    superior: "/\xa0\xa0\xa0会员管理"
                },
                component: () => import("../views/member/thememberlistDeta.vue")
            },
            {
                // 审核列表
                path: "/toapplyTheList",
                name: "toapplyTheList",
                meta: {
                    title: "/\xa0\xa0\xa0审核列表",
                    superior: "/\xa0\xa0\xa0会员管理"
                },
                component: () => import("../views/member/toapplyTheList.vue")
            },
            {
                // 审核详情
                path: "/toapplyTheListDeta",
                name: "toapplyTheListDeta",
                meta: {
                    title: "/\xa0\xa0\xa0审核详情",
                    superior: "/\xa0\xa0\xa0会员管理"
                },
                component: () => import("../views/member/toapplyTheListDeta.vue")
            },
            {
                // 审核列表详情
                path: "/toapplyaudit",
                name: "toapplyaudit",
                meta: {
                    title: "/\xa0\xa0\xa0会员列表",
                    superior: "/\xa0\xa0\xa0会员管理"
                },
                component: () => import("../views/member/toapplyaudit.vue")
            },
            //``````````````````房源管理`````````````````

            {
                // 房源管理-房源发布
                path: "/rental",
                name: "rental",
                meta: {
                    title: "/\xa0\xa0\xa0房源发布",
                    superior: "/\xa0\xa0\xa0房源管理"
                },
                component: () => import("../views/housing/rental.vue")
            },
            {
                // 房源管理-房源发布
                path: "/finish",
                name: "finish",
                meta: {
                    title: "/\xa0\xa0\xa0房源发布",
                    superior: "/\xa0\xa0\xa0房源管理"
                },
                component: () => import("../components/rentalList/finish.vue")
            },
            // 房源管理-房源规格
            {
                path: "/housingSpecifications",
                name: "housingSpecifications",
                meta: {
                    title: "/\xa0\xa0\xa0房源规格",
                    superior: "/\xa0\xa0\xa0房源管理"
                },
                component: () => import("../views/management/housingSpecifications.vue")
            },
            // 房源管理-房源列表
            {
                path: "/managementList",
                name: "managementList",
                meta: {
                    title: "/\xa0\xa0\xa0房源列表",
                    superior: "/\xa0\xa0\xa0房源管理"
                },
                component: () => import("../views/management/managementList.vue")
            },
            // 房源管理-房源列表
            {
                path: "/nav",
                name: "nav",
                meta: {
                    title: "/\xa0\xa0\xa0位置地标管理",
                    superior: "/\xa0\xa0\xa0房源管理"
                },
                component: () => import("../views/management/nav.vue")
            },
            {
                // 房源详情
                path: "/productDetails",
                name: "productDetails",
                meta: {
                    title: "/\xa0\xa0\xa0房源详情",
                    superior: "/\xa0\xa0\xa0房源管理"
                },
                component: () => import("../views/management/productDetails.vue")
            },
            {
                // 房源审核列表
                path: "/HousingAuditList",
                name: "HousingAuditList",
                meta: {
                    title: "/\xa0\xa0\xa0审核管理",
                    superior: "/\xa0\xa0\xa0房源管理"
                },
                component: () => import("../views/management/HousingAuditList.vue")
            },
            {
                // 房源审核详情
                path: "/HousingAudit",
                name: "HousingAudit",
                meta: {
                    title: "/\xa0\xa0\xa0房源审核",
                    superior: "/\xa0\xa0\xa0房源管理"
                },
                component: () => import("../views/management/HousingAudit.vue")
            },
            {
                // 房源订单列表
                path: "/orderManagementList",
                name: "orderManagementList",
                meta: {
                    title: "/\xa0\xa0\xa0订单列表",
                    superior: "/\xa0\xa0\xa0订单管理"
                },
                component: () =>
                    import("../views/orderManagement/orderManagementList.vue")
            },
            {
                // 订单详情
                path: "/orderDetails",
                name: "orderDetails",
                meta: {
                    title: "/\xa0\xa0\xa0订单详情",
                    superior: "/\xa0\xa0\xa0订单管理"
                },
                component: () => import("../views/orderManagement/orderDetails.vue")
            },
            {
                // --------------新房态------------------
                path: "/RoomStatus",
                name: "RoomStatus",
                meta: {
                    title: "/\xa0\xa0\xa0房态管理",
                    superior: "/\xa0\xa0\xa0房态管理"
                },
                component: () => import("../components/RoomStatus/index.vue")
            },
            //-------------新房态------------------
            {
                // 日历
                path: "/calendar",
                name: "calendar",
                meta: {
                    title: "/\xa0\xa0\xa0日历",
                    superior: "/\xa0\xa0\xa0日历"
                },
                component: () => import("../components/calendar.vue")
            },
            {
                // 消息
                path: "/communication",
                name: "communication",
                meta: {
                    title: "/\xa0\xa0\xa0消息",
                    superior: "/\xa0\xa0\xa0消息"
                },
                component: () => import("../views/management/communication.vue")
            },
            {
                // 房价管理
                path: "/priceStatus",
                name: "priceStatus",
                meta: {
                    title: "/\xa0\xa0\xa0房价管理",
                    superior: "/\xa0\xa0\xa0房价管理"
                },
                component: () => import("../components/priceStatus/index.vue")
            },
            // ==============途家对接============
            {
                // 房价管理
                path: "/stores",
                name: "stores",
                meta: {
                    title: "/\xa0\xa0\xa0门店管理",
                    superior: "/\xa0\xa0\xa0门店管理"
                },
                component: () => import("../views/WayHome/stores.vue")
            },
            {
                // 渠道直连
                path: "/directChannelConnection",
                name: "directChannelConnection",
                meta: {
                    title: "/\xa0\xa0\xa0渠道直连",
                    superior: "/\xa0\xa0\xa0渠道直连"
                },
                component: () => import("../views/directChannelConnection/directChannelConnection.vue")
            },
            {
                // 渠道直连 关联页
                path: "/listingLinking",
                name: "listingLinking",
                meta: {
                    title: "/\xa0\xa0\xa0关联页",
                    superior: "/\xa0\xa0\xa0渠道直连"
                },
                component: () => import("../views/directChannelConnection/listingLinking/listingLinking.vue")
            },
            {
                // 渠道直连 房源列表页
                path: "/allListings",
                name: "allListings",
                meta: {
                    title: "/\xa0\xa0\xa0查看所有房源",
                    superior: "/\xa0\xa0\xa0渠道直连"
                },
                component: () => import("../views/directChannelConnection/allListings/allListings.vue")
            }
        ]
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    // 对于全部页面要做一个校验，只有登录过后才能进入我们的主页，否则不让进去
    // tokenStr这个单词专门用来判断用户 是否已经登录了，如果有值就登录，如果没有证明用户没有登录
    const tokenStr = window.sessionStorage.getItem("user_token");
    // 这个函数 要是不写没问题，如果写了，就一定要写一个 next() 相当于放行的意思
    if (to.path === "/login" || to.path === "/auth") return next();
    if (!tokenStr) return next("/login");
    if (to.path === "/login") {
        if (tokenStr) return next("/user")
    }
    // store.commit("setMT");
    next();
});

export default router;
